class ErrorDetailsModalCtrl {

    constructor($scope, $uibModalInstance, error, ErrorUtils) {
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;
        this.$scope.ok = this.ok.bind(this);
        this.$scope.cancel = this.cancel.bind(this);
        this.$scope.error = ErrorUtils.normalizeErrorBody(error);
    }

    ok() {
        this.$uibModalInstance.close();
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

}

angular.module("cpm").controller("ErrorDetailsModalCtrl", ['$scope', '$uibModalInstance', 'error', 'ErrorUtils', ErrorDetailsModalCtrl]);
